export const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const getBrandLogo = (fallback) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    return userDetails?.company?.brandLogo || fallback;
  } catch {
    return fallback;
  }
};